import React, { Component } from 'react';
import PropTypes from 'prop-types';
import YesNoDescriptionInput from '../YesNoDescriptionInput';
import './YesNoDescriptionInputGroup.scss';

const getValueField = (option, value, field) => {
  const optionValue = value && value.find((v) => v.id === option.id);
  return optionValue && optionValue[field];
};

class YesNoDescriptionInputGroup extends Component {
  constructor(props) {
    super(props);
    this.renderOne = this.renderOne.bind(this);
  }

  renderOne(option, index) {
    const {
      value, formKey, errors, requiredDescriptionValues,
      exampleText, onAnswerChange, textAreaPrompt,
    } = this.props;

    const selectedValue = getValueField(option, value, 'selected');
    const descValue = getValueField(option, value, 'desc');

    const descRequired = requiredDescriptionValues.indexOf(selectedValue) > -1
    || selectedValue === null;

    let error = null;
    if ((!descValue || descValue.trim() === '' || (descValue.trim().length < 50 && formKey === 'responsibility_areas')) && descRequired) {
      error = errors[`${formKey}_${option.id}`];
    }

    return (
      <div key={option.id}>
        <YesNoDescriptionInput
          formKey={formKey}
          index={index}
          option={option}
          value={value}
          exampleText={exampleText}
          selectedValue={selectedValue}
          onAnswerChange={onAnswerChange}
          error={error}
          textAreaPrompt={textAreaPrompt}
        />
      </div>
    );
  }

  render() {
    const { options } = this.props;
    return (
      <div className="yes-no-description-input-group">
        {options.map((option, index) => (
          this.renderOne(option, index + 1)
        ))}
      </div>
    );
  }
}

YesNoDescriptionInputGroup.propTypes = {
  formKey: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  value: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    selected: PropTypes.string,
    desc: PropTypes.string,
  })),
  onAnswerChange: PropTypes.func.isRequired,
  errors: PropTypes.shape({}),
  requiredDescriptionValues: PropTypes.arrayOf(PropTypes.string),
  exampleText: PropTypes.string,
  textAreaPrompt: PropTypes.string,
};

YesNoDescriptionInputGroup.defaultProps = {
  value: [],
  errors: {},
  requiredDescriptionValues: [],
  exampleText: null,
  textAreaPrompt: 'Tell us more about that.',
};

export default YesNoDescriptionInputGroup;
